export * from './headers';

export const LIMIT_MAX = 5000;
export const CQL_FIND_ALL = 'cql.allRecords=1';
